import {
  CREATE_FAQ_SUCCESS,
  CREATE_FAQ_FAIL,
  RETRIEVE_FAQ_SUCCESS,
  RETRIEVE_FAQ_FAIL,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_FAQ_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_FAQ_SUCCESS:
      return payload;

    case RETRIEVE_FAQ_FAIL:
      return [...datas];

    case UPDATE_FAQ_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_FAQ_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
